<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" [modalHelpIndex]="modalHelpIndex"
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()"
    (closeButtonActionEmt)="closeModal(userHasPasswordChanged)" [modalClass]="modalClass"
    [isPrimaryBtnEnabled]="isPrimaryButtonEnabled() && !isBusy" [secondaryButtonLabel]="secondaryButtonLabel"
    [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage">
    <div class="content">
        <div class="left-settings-panel">
            <div class="modal-row" [hidden]="commonService.isTPAuthEnabledSystem">
                <div class="name-description-container">
                    <res-name-description [name]="nameDescriptionComponent.name" [nameLabel]="'Username:'"
                        [isDescriptionHidden]="isDescriptionHidden" [validateNameRequest]="validateNameRequest"
                        [attr.maxlength]="nameDescriptionComponent.maxNameLength" [validateName]="true"
                        [automationId]="modalAutomationId" [isNameDisabled]="isEditUser">
                    </res-name-description>
                </div>
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto">
                    <label for="email" requiredAsterisk [isRequired]="!isRetryTpAuth">Email: </label>
                </div>
                <div class="modal-row-column-max">
                    <input type="text" required [(ngModel)]="email"
                        [disabled]="isEditUser && commonService.isTPAuthEnabledSystem"
                        [attr.data-automation-id]="modalAutomationId + '-email-input'" ngModel name="email"
                        (focus)="onFocus()" (blur)="onEmailBlur()" (ngModelChange)="onEmailChanged()">
                    <div class="validation-popovers">
                        <div [(resScrollablePopover)]="showPopover" [popoverErrorMessage]="emailErrorPopoverMessage"
                            popoverType="error" popoverPlacement="bottom" [popoverOffsetTop]="25"
                            [popoverOffsetLeft]="9" [isSingleLine]="true"
                            [popoverAutomationId]="modalAutomationId  + '-email-validation-label'">
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto">
                    <label for="role">Role:</label>
                </div>
                <div class="modal-row-column-max">
                    <select class="input-fields" [(ngModel)]="roleHandle" (ngModelChange)="changeRole()"
                        [disabled]="isRetryTpAuth" [attr.data-automation-id]="modalAutomationId + '-role-dropdown'">
                        <option *ngFor="let role of roleList" [ngValue]="role.handle" [hidden]="hideRoleOption(role)">
                            {{role.name}}</option>
                    </select>
                </div>
            </div>

            <div class="modal-row"
                *ngIf="(!commonService.isTPAuthEnabledSystem && isEditUser) || isRetryTpAuth || !isEditUser">
                <div class="modal-row-column-auto">
                    <label for="password" requiredAsterisk
                        [isRequired]="(!isEditUser && enablePasswordFieldForTPAuth) || isRetryTpAuth">Password: </label>
                </div>
                <form #contentForm="ngForm" class="modal-row-column-max row-position-relative">
                    <!-- New User -->
                    <input [ngClass]="!commonService.isTPAuthEnabledSystem? 'input-password' : ''"
                        [ngStyle]="{'width': !commonService.isTPAuthEnabledSystem ? '155px' : '100%'}" required
                        type="password"
                        *ngIf="(!isEditUser && enablePasswordFieldForTPAuth) || (!isEditUser && !commonService.isTPAuthEnabledSystem)"
                        ngModel [value]="password" [attr.data-automation-id]="modalAutomationId + '-password-input'"
                        name="password" resIconSwitch
                        [initClass]="enablePasswordFieldForTPAuth ? 'fa fa-eye fa-eye-tpauth' : 'fa fa-eye'"
                        [switchClass]="enablePasswordFieldForTPAuth ? 'fa fa-eye-slash fa-eye-slash-tpauth' : 'fa fa-eye-slash'"
                        elementAttributeName="type" elementAttributeValue="text"
                        [disabled]="isEditUser || !enablePasswordFieldForTPAuth" maxlength="64"
                        (ngModelChange)="onPasswordChanged(); passwordPolicy?.checkRequirements(password)"
                        (focusout)="onPasswordInputFocusedOutEvent()">

                    <input [ngClass]="!commonService.isTPAuthEnabledSystem? 'input-password' : ''"
                        [ngStyle]="{'width': !commonService.isTPAuthEnabledSystem ? '155px' : '100%'}" required
                        type="password"
                        *ngIf="!isEditUser && !enablePasswordFieldForTPAuth && commonService.isTPAuthEnabledSystem"
                        ngModel [value]="password" [attr.data-automation-id]="modalAutomationId + '-password-input'"
                        name="password" resIconSwitch [initClass]="'hidden'" [switchClass]=""
                        elementAttributeName="type" elementAttributeValue="text"
                        [disabled]="isEditUser || !enablePasswordFieldForTPAuth" maxlength="64"
                        (ngModelChange)="onPasswordChanged(); passwordPolicy?.checkRequirements(password)"
                        (focusout)="onPasswordInputFocusedOutEvent()">
                    <!-- Edit User -->
                    <input [ngClass]="!commonService.isTPAuthEnabledSystem? 'input-password' : ''"
                        [ngStyle]="{'width': !commonService.isTPAuthEnabledSystem ? '155px' : '100%'}" required
                        type="password" *ngIf="(isEditUser && !commonService.isTPAuthEnabledSystem) || isRetryTpAuth"
                        [(ngModel)]="password" [attr.data-automation-id]="modalAutomationId + '-password-input'" ngModel
                        name="password" resIconSwitch
                        [initClass]="isRetryTpAuth && commonService.isTPAuthEnabledSystem ? 'fa fa-eye fa-eye-tpauth' : 'hidden'"
                        elementAttributeName="type" elementAttributeValue="text"
                        [disabled]="isEditUser && !isRetryTpAuth" maxlength="64"
                        [switchClass]="commonService.isTPAuthEnabledSystem ? 'fa fa-eye-slash fa-eye-slash-tpauth' : 'fa fa-eye-slash'"
                        (ngModelChange)="onPasswordChanged(); passwordPolicy?.checkRequirements(password)"
                        (focusout)="onPasswordInputFocusedOutEvent()">
                </form>
                <div class="modal-row-column-max" *ngIf="!commonService.isTPAuthEnabledSystem">
                    <button type="button" [attr.data-automation-id]="modalAutomationId + '-change-password-button'"
                        class="secondary-button change-password" (click)="changePassword()" [disabled]="!isEditUser">
                        <i class="fa fa-key"></i>Change Password ...
                    </button>
                </div>
            </div>
            <div class="modal-row requirements-container"
                *ngIf="(enablePasswordFieldForTPAuth && !isEditUser) || isRetryTpAuth">
                <div class="requirements-header">
                    <span>Password must contain at least:</span>
                </div>
                <div class="password-requirements">
                    <div *ngIf="passwordPolicy?.minimumPasswordLength"
                        [class.valid]="passwordPolicy?.minimumPasswordLengthMet"
                        [class.invalid]="!passwordPolicy?.minimumPasswordLengthMet && passwordPolicy?.showInvalid">
                        <i class="fa" [class.fa-check]="passwordPolicy?.minimumPasswordLengthMet"
                            [class.fa-exclamation-circle]="!passwordPolicy?.minimumPasswordLengthMet && passwordPolicy?.showInvalid"></i>
                        {{passwordPolicy?.minimumPasswordLength}}<span>character</span><span
                            *ngIf="passwordPolicy?.minimumPasswordLength > 1">s</span>
                    </div>
                    <div *ngIf="passwordPolicy?.minimumUppercaseLetters"
                        [class.valid]="passwordPolicy?.minimumUppercaseLettersMet"
                        [class.invalid]="!passwordPolicy?.minimumUppercaseLettersMet && passwordPolicy?.showInvalid">
                        <i class="fa" [class.fa-check]="passwordPolicy?.minimumUppercaseLettersMet"
                            [class.fa-exclamation-circle]="!passwordPolicy?.minimumUppercaseLettersMet && passwordPolicy?.showInvalid"></i>
                        {{passwordPolicy?.minimumUppercaseLetters}}<span>uppercase letter</span><span
                            *ngIf="passwordPolicy?.minimumUppercaseLetters > 1">s</span>
                    </div>
                    <div *ngIf="passwordPolicy?.minimumLowercaseLetters"
                        [class.valid]="passwordPolicy?.minimumLowercaseLettersMet"
                        [class.invalid]="!passwordPolicy?.minimumLowercaseLettersMet && passwordPolicy?.showInvalid">
                        <i class="fa" [class.fa-check]="passwordPolicy?.minimumLowercaseLettersMet"
                            [class.fa-exclamation-circle]="!passwordPolicy?.minimumLowercaseLettersMet && passwordPolicy?.showInvalid"></i>
                        {{passwordPolicy?.minimumLowercaseLetters}}<span>lowercase letter</span><span
                            *ngIf="passwordPolicy?.minimumLowercaseLetters > 1">s</span>
                    </div>
                    <div *ngIf="passwordPolicy?.minimumNumbers" [class.valid]="passwordPolicy?.minimumNumbersMet"
                        [class.invalid]="!passwordPolicy?.minimumNumbersMet && passwordPolicy?.showInvalid">
                        <i class="fa" [class.fa-check]="passwordPolicy?.minimumNumbersMet"
                            [class.fa-exclamation-circle]="!passwordPolicy?.minimumNumbersMet && passwordPolicy?.showInvalid"></i>
                        {{passwordPolicy?.minimumNumbers}}<span>number</span><span
                            *ngIf="passwordPolicy?.minimumNumbers > 1">s</span>
                    </div>
                    <div *ngIf="passwordPolicy?.minimumSymbols" [class.valid]="passwordPolicy?.minimumSymbolsMet"
                        [class.invalid]="!passwordPolicy?.minimumSymbolsMet && passwordPolicy?.showInvalid">
                        <i class="fa" [class.fa-check]="passwordPolicy?.minimumSymbolsMet"
                            [class.fa-exclamation-circle]="!passwordPolicy?.minimumSymbolsMet && passwordPolicy?.showInvalid"></i>
                        {{passwordPolicy?.minimumSymbols}}<span>symbol</span><span
                            *ngIf="passwordPolicy?.minimumSymbols > 1">s (non-alphanumeric
                            characters</span><span *ngIf="passwordPolicy?.minimumSymbols < 2"> (non-alphanumeric
                            character</span>, i.e. !
                        &#64; # $ %)
                    </div>
                </div>
            </div>
            <div class="modal-row" disa>
                <div class="modal-row-column-auto">
                    <label for="firstName" requiredAsterisk [isRequired]="!isRetryTpAuth">First Name:
                    </label>
                </div>
                <div class="modal-row-column-max">
                    <input type="text" required [(ngModel)]="firstName" [disabled]="isRetryTpAuth"
                        [attr.data-automation-id]="modalAutomationId + '-first-name-input'" ngModel name="firstName">
                </div>
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto">
                    <label for="lastName" requiredAsterisk [isRequired]="!isRetryTpAuth">Last Name:
                    </label>
                </div>
                <div class="modal-row-column-max">
                    <input type="text" required [(ngModel)]="lastName" [disabled]="isRetryTpAuth"
                        [attr.data-automation-id]="modalAutomationId + '-last-name-input'" ngModel name="lastName">
                </div>
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto">
                    <label for="userDescriptionId">Description:</label>
                </div>
                <div class="modal-row-column-max">
                    <textarea id="userDescriptionId" [(ngModel)]="description" [disabled]="isRetryTpAuth"
                        [attr.data-automation-id]="modalAutomationId + '-description-input'"
                        [attr.maxlength]="nameDescriptionComponent.maxDescriptionLength" name="description"></textarea>
                </div>
            </div>
        </div>
        <div class="right-settings-panel">
            <div class="settings-panel-header">Authentication Options</div>
            <div class="modal-row top-padding">
                <div class="modal-row-column-auto">
                    <res-custom-checkbox name="authenticationPassword"
                        [automationId]="modalAutomationId + '-authentication-password'" [isDisabled]="true"
                        [(ngModel)]="authenticationPassword" content="Password">
                    </res-custom-checkbox>
                </div>
            </div>
            <div class="modal-row top-padding" *ngIf="!commonService.isTPAuthEnabledSystem">
                <div class="modal-row-column-auto">
                    <res-custom-checkbox name="mfa" [titleText]="tooltip" [isDisabled]="tooltip"
                        [attr.data-automation-id]="modalAutomationId + '-email-security-code'" [(ngModel)]="mfa"
                        content="Email Security Code" (ngModelChange)="onChangeSecurityCode()">
                    </res-custom-checkbox>
                </div>
            </div>
            <div class="modal-row top-padding" *ngIf="!commonService.isTPAuthEnabledSystem">
                <div class="modal-row-column-auto radio-column left-padding">
                    <res-custom-radio-button [automationId]="modalAutomationId + '-email-security-code-always'"
                        [isDisabled]="!mfa" [(ngModel)]="conditionalOnIPAddress" content="Always"
                        (ngModelChange)="onChangeSecurityCode()" name="conditionalOnIPAddress" [value]="false"
                        [titleText]="tooltip">
                    </res-custom-radio-button>
                    <res-custom-radio-button
                        [automationId]="modalAutomationId + '-email-security-only-if-ip-address-is-not-authorized'"
                        [isDisabled]="!mfa" [(ngModel)]="conditionalOnIPAddress" [titleText]="tooltip"
                        (ngModelChange)="onChangeSecurityCode()" content="Only if user's IP address is not authorized"
                        name="conditionalOnIPAddress" [value]="true">
                    </res-custom-radio-button>
                </div>
            </div>
            <div class="modal-row top-padding">
                <div class="modal-row-column-auto">
                    <res-custom-checkbox name="authorizeIPAddresses" [isDisabled]="disableAllOptions || isRetryTpAuth"
                        [automationId]="modalAutomationId + '-authorized IP addresses'"
                        [(ngModel)]="authorizeIPAddresses" content="Authorized IP addresses:"
                        (ngModelChange)="onChangeAuthorizedIP()" [titleText]="tooltip"
                        [isRequired]="mfa && conditionalOnIPAddress">
                    </res-custom-checkbox>
                </div>
            </div>
            <div class="modal-row ip-address-list">
                <res-key-value-list [placeholderField1]='"IPv4 address, subnet, or range ... "' [rows]="ipAddressesList"
                    [queryColumnHidden]="true" [removeBoarders]="true" [disabled]="!authorizeIPAddresses"
                    [automationId]="modalAutomationId + '-ip-addresses-list'" [validateName]="false"
                    [maxNameLength]="255">
                </res-key-value-list>
            </div>
            <div class="modal-row ip-example">
                <div class="modal-row ip-example-first-row">
                    <div class="modal-row-column-auto example">Example:</div>
                    <div class="modal-row-column-auto">192.168.0.1</div>
                </div>
                <div class="modal-row ip-example-row">192.168.0.1/16</div>
                <div class="modal-row ip-example-row">192.168.0.1-192.168.0.101</div>
            </div>
        </div>
    </div>
</res-base-modal>